<template>
  <div class="bg-gray overflow-auto q-mb-md">
    <div class="row q-col-gutter-md q-px-md q-py-xs items-center">
      <div class="col-6 col-lg-3">
        <q-input
          v-model="searchSync"
          dense
          label="Search"
          hint="Search by name, business name or email"
          @keydown.enter="$emit('search')"
        />
      </div>

      <div class="col-6 col-lg-3">
        <q-select
          v-model="sortSync"
          dense
          label="Sort"
          emit-value
          map-options
          hint="Sort user by account registration date"
          :options="sortOptions"
        />
      </div>

      <div class="col-6 col-lg-3">
        <q-select
          v-model="verificationSync"
          dense
          label="Verification status"
          emit-value
          map-options
          hint="Sort user by verification status"
          :options="verificationOptions"
        />
      </div>

      <div class="col-6 col-lg-3 flex justify-between">
        <q-btn outline color="primary" label="reset" icon="cached" @click="$emit('reset')" />
        <q-btn color="primary" label="search" icon="search" @click="$emit('search')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      type: String,
      required: true,
    },
    sort: {
      type: String,
      required: true,
    },
    verification: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sortOptions: [
        { label: 'Newest', value: '' },
        { label: 'Oldest', value: 'ASC' },
      ],
      verificationOptions: [
        { label: 'All', value: '' },
        { label: 'Rejected', value: 'rejected' },
        { label: 'Pending', value: 'pending' },
        { label: 'Verified', value: 'verified' },
      ],
    };
  },

  computed: {
    searchSync: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit('update:search', value);
      },
    },
    sortSync: {
      get() {
        return this.sort;
      },
      set(value) {
        this.$emit('update:sort', value);
      },
    },
    verificationSync: {
      get() {
        return this.verification;
      },
      set(value) {
        this.$emit('update:verification', value);
      },
    },
  },
};
</script>
